const agent = navigator.userAgent.toLowerCase();

// 모바일 환경
export const isMobile = agent.indexOf('mobile') !== -1;

// AOS 디바이스
export const isDeviceAOS = agent.indexOf('android') !== -1 && window.masterpick;
export const isDeviceWebAOS = agent.indexOf('android') !== -1;
// IOS 디바이스
export const isDeviceIOS =
	(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
	window.webkit &&
	window.webkit.messageHandlers;
export const isDeviceWebIOS =
	agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1;
// 푸쉬 fcm token 요청 함수
export const getPushToken = async () => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeGetPushToken();
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers?.nativeGetPushToken?.postMessage('');
};

// 푸쉬 권한 여부 요청 함수
export const getPushPermissionYn = () => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeCheckPermissionNotification();
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers?.nativeCheckPermissionNotification?.postMessage('');
};

// 푸쉬 권한 요청 함수
export const requestPermissionNotification = () => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeRequestPermissionNotification();
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers?.nativeRequestPermissionNotification?.postMessage('');
};

// 앱 버전 요청 함수
export const getAppVersion = () => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeGetAppVersion();
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers?.nativeGetAppVersion?.postMessage('');
};

// 디바이스 모델 요청 함수
export const getDevice = () => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeGetDeviceType();
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers?.nativeGetDeviceType?.postMessage('');
};

// 외부 URL 웹 오픈
export const openNativeBrowser = (url: string) => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeUrlOpenBrowser(url);
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers?.nativeUrlOpenBrowser?.postMessage(url);
};

// 웹에서 앱스토어 오픈
export const openNativeWebAppStore = () => {
	// ANDROID
	if (isDeviceWebAOS)
		window.location.href = 'https://play.google.com/store/apps/details?id=com.first_partners.masterpick';
	// IOS
	if (isDeviceWebIOS) window.location.href = 'https://apps.apple.com/kr/app/id6444056769';
};

// 앱스토어 오픈
export const openNativeAppStore = () => {
	// ANDROID
	if (isDeviceAOS) window.location.href = 'https://play.google.com/store/apps/details?id=com.first_partners.masterpick';
	// IOS
	if (isDeviceIOS) window.location.href = 'https://apps.apple.com/kr/app/id6444056769';
};

// 엑셀다운로드 오픈
export const openNativeExcelDownload = (filePath: string, title?: string) => {
	// ANDROID
	if (isDeviceAOS) window.masterpick.nativeExcelDownload(filePath, title);
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers.nativeExcelDownload.postMessage(`${filePath},${title}`);
};

// 외부 URL 웹 오픈
export const openNativeLocation = (url: string) => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeUrlOpenBrowser(url);
	// IOS
	if (isDeviceIOS) window.webkit?.messageHandlers?.nativeUrlOpenBrowser?.postMessage(url);
};

// 인앱 결제 요청
export const requestPaymentInApp = (product_id: string) => {
	// ANDROID
	if (isDeviceAOS) window.masterpick?.nativeInAppPurchase(product_id);
	// IOS
	if (isDeviceIOS)
		window.webkit?.messageHandlers?.nativeInAppPurchase?.postMessage({
			productId: product_id,
		});
};

export const checkWebOrApp = (): 'AOS' | 'IOS' | 'Web' => {
	const agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1 && window.masterpick) {
		return 'AOS';
	} else if (
		(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
		window.webkit &&
		window.webkit.messageHandlers
	) {
		return 'IOS';
	} else {
		return 'Web';
	}
};
